import isVisible from "../utils/is-visible";

import ButtonBox from "./button-box";

const selectorSettings = ".js-settings";
const selectorSettingsButtons = ".js-settings__button";

export default class SettingsBar extends ButtonBox {
  constructor($settings, $buttons) {
    super($settings, $buttons);

    this.$settingsButtons = [
      ...$settings.querySelectorAll(".js-settings__settings-button"),
    ];

    this.initBar();
  }

  initBar() {
    this.initFocusin();
    this.initContrasts();
  }

  initFocusin() {
    document.addEventListener(
      "focusin",
      () => {
        if (
          this.$settingsButtons.includes(document.activeElement) &&
          !this.isOpen
        ) {
          this.updateCurrentButton(this.getVisibleButton());
          this.updateSizes();
          this.updateStyles();
          this.open();
        }
      },
      true
    );
  }

  initContrasts() {
    this.setContrast(window.localStorage.getItem("contrast"));

    this.$settingsButtons.forEach(($settingsButton) => {
      $settingsButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.removeAllContrasts();
        this.setContrast($settingsButton.dataset.class);
      });
    });
  }

  setContrast(className = "deafult") {
    window.localStorage.setItem("contrast", className);
    document.body.classList.add(className);
  }

  removeAllContrasts() {
    this.$settingsButtons.forEach(($button) =>
      document.body.classList.remove($button.dataset.class)
    );
  }

  open() {
    super.open();
    document.body.classList.add("settings-menu-open");
  }

  close() {
    super.close();
    document.body.classList.remove("settings-menu-open");
  }

  getVisibleButton() {
    return [...this.$buttons].filter(($button) => isVisible($button))[0];
  }

  static bindDOM($container = document.body) {
    const instances = [];
    $container.querySelectorAll(selectorSettings).forEach(($settings) => {
      const $buttons = $container.querySelectorAll(selectorSettingsButtons);
      instances.push(new SettingsBar($settings, $buttons));
    });
    return instances;
  }
}
